import React from 'react';
import { BookType } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import BookContent from './BooksContent';

const LetterBooksContent: React.FC<{ fromRoute?: string }> = ({ fromRoute }) => {
  return <BookContent bookType={BookType.LETTER_BOOK} fromRoute={fromRoute} />;
};

export default LetterBooksContent;
